import Page from "../../models/api/Page";
import {Task} from "./Task";
import {Api} from "../Api";
import {HttpClient} from "../_http/HttpClient";
import {PageRequest} from "../../models/api/PageRequest";
import {SortedRequest} from "../../models/api/SortedRequest";

export type SearchQuery = PageRequest & SortedRequest;

export type AssignedToMeQuery = PageRequest & SortedRequest;

export type CreatePayload = {
    title: string;
    description?: string;
}

export class TaskAPI {
    static getList(query: SearchQuery): Promise<Page<Task>> {
        const url = Api.getUrl('/task');
        return HttpClient.get<Page<Task>>(url, query);
    }

    static getById(id: string): Promise<Task> {
        const url = Api.getUrl(`/task/${id}`);
        return HttpClient.get<Task>(url);
    }

    static create(p: CreatePayload): Promise<Task> {
        const url = Api.getUrl('/task/create');
        return HttpClient.post<Task>(url, {}, p);
    }

    static getAssignedToMe(query: AssignedToMeQuery): Promise<Page<Task>> {
        const url = Api.getUrl('/task/assigned-to-me');
        return HttpClient.get<Page<Task>>(url, query);
    }

    static deleteById(id: string): Promise<Response> {
        const url = Api.getUrl(`/task/${id}`);
        return HttpClient.deleteAndExpectNoContent(url, {}, {});
    }

    static markAsDone(id: string): Promise<Task> {
        const url = Api.getUrl(`/task/${id}/finish`);
        return HttpClient.put(url, {}, {});
    }
}